import type { StagesEditorScope } from '@recruitee/offers-ui';

export enum OCTrackingEventName {
  DialogSetTimeButtonClick = '[Overdue/CustomModal] SetTime_ButtonClick',
  LearnMoreClick = '[DiscoveryTooltip/Overdue] LearnMore_ButtonClick',
  NotificationFollowedCandidatesClick = '[Notifications] FollowedCandidatesOverdue_Click',
  NotificationFollowedJobClick = '[Notifications] FollowedJobOverdue_Click',
}

export enum OverdueTime {
  NoTime = 'No time',
  SevenDays = '7 days',
  FourteenDays = '14 days',
  TwentyOneDays = '21 days',
  Custom = 'Custom',
}

export type OverdueTimeProperties = {
  OverdueTime: OverdueTime;
};

export type OverdueCustomProperties = {
  OverdueCustom: string;
};

export type StagesEditorProperties = {
  StagesEditorView: StagesEditorScope;
};

type OverdueNotificationsProperties = {
  OverdueNotifications: 'web' | 'email';
};

interface BaseEvent {
  name: OCTrackingEventName;
  properties?:
    | OverdueTimeProperties
    | OverdueCustomProperties
    | StagesEditorProperties
    | OverdueNotificationsProperties;
}

interface SetTimeClickEvent extends BaseEvent {
  name: OCTrackingEventName.DialogSetTimeButtonClick;
  properties: OverdueCustomProperties;
}

interface LearnMoreClickEvent extends BaseEvent {
  name: OCTrackingEventName.LearnMoreClick;
  properties: StagesEditorProperties;
}

interface OverdueNotificationClickEvent extends BaseEvent {
  name:
    | OCTrackingEventName.NotificationFollowedCandidatesClick
    | OCTrackingEventName.NotificationFollowedJobClick;
  properties: OverdueNotificationsProperties;
}

export type OverdueTrackingEvent =
  | SetTimeClickEvent
  | LearnMoreClickEvent
  | OverdueNotificationClickEvent;
